import { noop } from 'rxjs';
import { NULL_SERVICE, Service } from '../base/service';

export interface SelectionService extends Service {
  readonly isActive: boolean;
  readonly selectedText?: string;

  moveToEnd(): void;
  selectAll(): void;
  deselect(): void;
}

export const NULL_SELECTION_SERVICE: SelectionService = {
  ...NULL_SERVICE,
  isActive: false,
  moveToEnd: noop,
  selectAll: noop,
  deselect: noop,
};
